import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Table,
  Card,
  CardBody,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  UncontrolledTooltip

} from "reactstrap";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import './style.css'
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import CustomMonthPicker from "common/CustomMonthPicker";
import TableContainer from "components/Common/TableContainer";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { fetchActiveEmployees, fetchEmployeeSalaryIncrement, fetchCategory, fetchDepartment, fetchDesignation, getfinancialincrementtypes, saveEmployeeSalaryIncrementCTC, fetchEmployeeSalaryIncrementSavedCTC, fetchEmployeeDropdown, clearapproveError } from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { set } from "store";
import dayjs from "dayjs";
import CustomDatePicker from "common/CustomDatePicker";
import Swal from "sweetalert2";
import { showToast, showConfirm } from "../../../../common/Toaster";

const IncrementUpdate = () => {
  const [open, setOpen] = useState('1');
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [employeeDataSelected, setEmployeeDataSelected] = useState(null);
  const [emp_personnel, setemp_personnel] = useState(null);
  const [emp_oldctc, setemp_oldctc] = useState(null);
  const [emp_newctc, setEmpNewCtc] = useState([]);
  const [showFromDetails, setShowFromDetails] = useState(false);
  const [oldpfctc, setoldpfct] = useState(null);
  const [newCtcMode, setNewCtcMode] = useState("percentage");
  const [filteredData, setFilteredData] = useState([]);
  const [grosscheck, setgrosscheck] = useState([]);
  const [financialYearRange, setFinancialYearRange] = useState({
    start: null,
    end: null,
  });
  const [month, setMonth] = useState(null);

  const {
    employees,
    employeeSalaryIncrement,
    categoryList,
    departmentList,
    finacial_types,
    designationList,
    employeeSalaryIncrementSavedCTC,
    saveIncrementSuccess,
    dropdownData,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    employees: state.EmployeeDetailsReducer?.employeesActiveList ?? [],
    employeeSalaryIncrement: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.employeeSalaryIncrement ?? [],
    departmentList: state.EmployeeDetailsReducer?.departmentList ?? [],
    designationList: state.EmployeeDetailsReducer?.designationList ?? [],
    dropdownData: state.EmployeeDetailsReducer?.dropdownData ?? {},
    finacial_types: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.finacial_types,
    categoryList: state.EmployeeDetailsReducer?.categoryList ?? [],
    employeeSalaryIncrementSavedCTC: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.employeeSalaryIncrementSavedCTC ?? [],
    loading: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.loading,
    error: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.error,
    success: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.success,
    saveIncrementSuccess: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.saveIncrementSuccess,
  }));

  useEffect(() => {
    resetFormData();
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchActiveEmployees(unitId));
    dispatch(fetchCategory(authUserDetails[0].unit_id));
    dispatch(fetchDepartment(authUserDetails[0].unit_id));
    dispatch(fetchDesignation(authUserDetails[0].unit_id));
    dispatch(getfinancialincrementtypes(authUserDetails[0].unit_id));
    dispatch(fetchEmployeeDropdown(unitId));
  }, [dispatch]);

  useEffect(() => {
    if (success === true || authDetails) {
      const formData = new FormData();
      formData.append("create_by", authDetails?.user_id);
      formData.append("unit_id", authDetails?.unit_id);
      dispatch(fetchEmployeeSalaryIncrementSavedCTC(formData));
    }
  }, [success, authDetails, dispatch]);

  useEffect(() => {
    if (saveIncrementSuccess) {
      resetFormData();
      setEmployeeDataSelected(null);
      setEmpNewCtc([]);
      setemp_oldctc([]);
      setemp_personnel(null);
      setMonth(null);
      dispatch({ type: "RESET_SAVE_INCREMENT_STATUS" });
    }
  }, [saveIncrementSuccess, dispatch]);

  const toggle = (id) => { setOpen((prevOpen) => (prevOpen === id ? '' : id)); };
  const [oldCTC, setOldCTC] = useState({ basic: 0, hra: 0, conveyance: 0, washing: 0, employerESI: 0, employerPF: 0, totalCTC: 0, esi: 0, employeePF: 0, gross: 0, takeHome: 0 });

  const columns = [
    { Header: "S.No", Cell: ({ row }) => employeeSalaryIncrementSavedCTC.length - row.index, className: "serial-no", applyHeaderClass: true, },
    { Header: "Code", accessor: "emp_no" },
    { Header: "Name", accessor: "emp_name" },
    { Header: "Financial Year", accessor: "financial_year" },
    { Header: "Inc Month", accessor: "increment_month" },
    { Header: "Increment Type", accessor: "increment_type" },
    { Header: "OLD CTC", accessor: "old_ctc" },
    { Header: "NEW CTC", accessor: "new_ctc" },
    { Header: "Applied On", accessor: "create_date" },
    { Header: "Status", accessor: "increment_status" },
  ];

  const handleSearch = () => {
    let filtered = Array.isArray(employeeSalaryIncrementSavedCTC) ? [...employeeSalaryIncrementSavedCTC] : [];
    if (formik.values.finyear?.fin_year) {
      filtered = filtered.filter((item) => item.financial_year === formik.values.finyear.fin_year);
    }
    if (formik.values.increment_types?.label) {
      filtered = filtered.filter((item) => item.increment_type === formik.values.increment_types.label);
    }
    if (month) {
      const formattedMonth = dayjs(month).startOf("month").format("YYYY-MM-DD");
      filtered = filtered.filter((item) => item.increment_month === formattedMonth);
    }
    setFilteredData(filtered);
  };

  const handleEmployeeChange = (selected) => {
    formik.resetForm();
    setEmpNewCtc([]);
    setemp_oldctc([]);
    setemp_personnel(null);
    setOldCTC({
      basic: 0,
      hra: 0,
      conveyance: 0,
      washing: 0,
      employerESI: 0,
      employerPF: 0,
      totalCTC: 0,
      esi: 0,
      employeePF: 0,
      gross: 0,
      takeHome: 0
    });
    setNewCtcMode("percentage");
    if (selected) {
      formik.setFieldValue("employee", selected);
      findEmpSalaryIncrement(selected);
    }
  };

  const ShowDetails = (selectedOption) => {
    if (selectedOption?.value === "2" || selectedOption?.value === "3") {
      setShowFromDetails(true);
    } else {
      setShowFromDetails(false);
    }
  }

  const getFinancialYearRange = (finYear) => {
    if (!finYear) return { start: null, end: null };
    const [startYear, endYear] = finYear.split("-");
    return {
      start: dayjs(`${startYear}-04-01`),
      end: dayjs(`${endYear}-03-31`),
    };
  };

  const isGrossValid = () => {
    const newGross = (emp_newctc || []).reduce(
      (sum, item) => sum + parseFloat(item.per_month || 0),
      0
    );
    const oldGross = (emp_oldctc || []).reduce(
      (sum, item) => sum + parseFloat(item.per_month || 0),
      0
    );
    const increment = parseFloat(formik.values.increment_amount || 0);
    const allowedGross = oldGross + increment;
    return {
      isValid: newGross === allowedGross,
      newGross,
      allowedGross
    };
  };

  const formik = useFormik({
    enableReinitialize: true,
    increment_types: "1",
    initialValues: {
      employee: null,
      finyear: null,
      increment_types: null,
      category: null,
      department: null,
      designation: null,
      employment_type: null,
      increment_amount: "",
      remarks: "",
      month: null,
      financialMonth: null,
    },
    validationSchema: Yup.object({
      employee: Yup.object().nullable().typeError("Employee is required").required("Employee is required"),
      month: Yup.date().nullable().required("Increment Month is required"),
      finyear: Yup.object().nullable().required("Financial Year is required"),
      increment_types: Yup.object().nullable().required("Increment Type is required"),
      category: Yup.object().when([], { is: () => showFromDetails, then: (schema) => schema.nullable().required("Category is required"), otherwise: (schema) => schema.nullable(), }),
      department: Yup.object().when([], { is: () => showFromDetails, then: (schema) => schema.nullable().required("Department is required"), otherwise: (schema) => schema.nullable(), }),
      designation: Yup.object().when([], { is: () => showFromDetails, then: (schema) => schema.nullable().required("Designation is required"), otherwise: (schema) => schema.nullable(), }),
      increment_amount: Yup.number().typeError("Must be a number").min(0, "Increment amount cannot be negative").required("Increment amount is required"),
      remarks: Yup.string().when([], { is: () => showFromDetails, then: (schema) => schema.nullable().required("Remarks is required"), otherwise: (schema) => schema.nullable(), }),
      financialMonth: Yup.date().nullable().required("Financial Month is required"),
      employer_esi_percent: employeeSalaryIncrement?.emp_oldpfctc?.employer_esi_percent || "",
    }
    ),
    onSubmit: (values, { resetForm }) => {
      if (!values.employee?.value) return;

      if (newCtcMode === "manual") {
        const { isValid, newGross, allowedGross } = isGrossValid();
        if (!isValid) {
          showToast({ icon: "error", title: "Validation Error", text: `New CTC Gross (${newGross}) must be equal to new gross (${allowedGross})` });
          return;
        }
      }

      const formData = new FormData();

      formData.append("emp_id", values.employee?.value || 0);
      formData.append("fy_id", values.finyear?.value || 0);
      // formData.append("increment_month", month ? dayjs(month).format("YYYY-MM") : "");
      formData.append("increment_month", values.financialMonth ? dayjs(values.financialMonth).startOf("month").format("YYYY-MM-DD") : "");
      formData.append("increment_type", values.increment_types?.value || 0);

      formData.append("from_cat_id", emp_personnel?.emp_catgryid || 0);
      formData.append("to_cat_id", values.category?.value || 0);

      formData.append("from_dept_id", emp_personnel?.department_id || 0);
      formData.append("to_dept_id", values.department?.value || 0);

      formData.append("from_desig_id", emp_personnel?.desig_id || 0);
      formData.append("to_desig_id", values.designation?.value || 0);

      formData.append("from_emptype_id", 0);
      formData.append("to_emptype_id", values.employment_type?.value || 0);

      formData.append("increment_amount", values.increment_amount || 0);
      formData.append("increment_remarks", values.remarks || "");
      formData.append("increment_date", values.month || null);
      formData.append("remarks", values.remarks || "");

      let employee_salary = {
        sal:
          emp_newctc?.map((item) => ({
            payallwonceid: item.pay_allwonce_id,
            adtype: "1",
            percentage: Number(item.percentage) || 0,
            per_month: Number(item.per_month) || 0,
            salary_status: "1",
          })) || [],
      };

      const extraComponents = [
        { payallwonceid: 1, adtype: 2, salary_status: 1, percentage: Number(values.employee_esi_percent) || 0, per_month: Number(values.employer_esi_amount) || 0, },
        { payallwonceid: 1, adtype: 2, salary_status: 2, percentage: Number(values.employee_esi_percent) || 0, per_month: Number(values.employee_esi_amount) || 0, },
        { payallwonceid: 2, adtype: 2, salary_status: 1, percentage: Number(values.employee_pf_percent) || 0, per_month: Number(values.employer_pf_amount) || 0, },
        { payallwonceid: 2, adtype: 2, salary_status: 2, percentage: Number(values.employee_pf_percent) || 0, per_month: Number(values.employee_pf_amount) || 0, },
      ];

      employee_salary.sal.push(...extraComponents);
      formData.append("lst_employee_salary", JSON.stringify(employee_salary));
      formData.append("unit_id", authDetails?.unit_id || 0);
      formData.append("create_by", authDetails?.user_id || 0);
      dispatch(saveEmployeeSalaryIncrementCTC(formData));
      resetForm();
    }
  });

  const findEmpSalaryIncrement = (empData, categoryId = null) => {
    if (empData) {
      const formData = new FormData();
      formData.append("emp_id", empData.value);
      const incrementType = categoryId ? formik.values.increment_types?.value || 0 : 0;
      formData.append("increment_type", incrementType);
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("to_cat_id", categoryId || 0);
      dispatch(fetchEmployeeSalaryIncrement(formData));
    }
  }

  useEffect(() => {
    if (employeeSalaryIncrement?.emp_personnel?.length > 0) { setemp_personnel(employeeSalaryIncrement?.emp_personnel[0]); }
    if (employeeSalaryIncrement?.emp_oldctc?.length > 0) { setemp_oldctc(employeeSalaryIncrement?.emp_oldctc) }
    if (employeeSalaryIncrement?.emp_newctc?.length > 0 && !formik.values.increment_amount) {
      setEmpNewCtc(employeeSalaryIncrement?.emp_newctc)
    }
  }, [employeeSalaryIncrement])

  useEffect(() => {
    if (success) {
      let filtered = Array.isArray(employeeSalaryIncrementSavedCTC) ? [...employeeSalaryIncrementSavedCTC] : [];

      if (formik.values.finyear?.fin_year) {
        filtered = filtered.filter(
          (item) => item.financial_year === formik.values.finyear.fin_year
        );
      }

      if (formik.values.increment_types?.label) {
        filtered = filtered.filter(
          (item) => item.increment_type === formik.values.increment_types.label
        );
      }

      if (month) {
        const formattedMonth = dayjs(month)
          .startOf("month")
          .format("YYYY-MM-DD");

        filtered = filtered.filter(
          (item) => item.increment_month === formattedMonth
        );
      }

      setFilteredData(filtered);
    }
  }, [success, employeeSalaryIncrementSavedCTC, formik.values, month]);

  let categoryOptions = [], deptOptions = [], desigOption = [], financial_year = [], increment_type = [];

  categoryOptions = (categoryList || []).map(item => ({ label: item.empCategory, value: item.empCatgryid }));
  deptOptions = (departmentList || []).map(item => ({ label: item.departmentcode, value: item.departmentId }));
  desigOption = (designationList || []).map(item => ({ label: item.designation, value: item.desig_id }));
  financial_year = (finacial_types?.finacial_year || []).map(item => ({ label: item.fin_year, value: item.fy_id }));
  increment_type = (finacial_types?.increment_type || []).map(item => ({ label: item.inc_type, value: item.increment_type_id }));
  const emptypeoption = dropdownData?.empment_type?.map((item) => ({ label: item.emp_type, value: item.emptype_id, })) || [];

  useEffect(() => {
    if (employeeSalaryIncrement?.emp_oldpfctc?.length > 0) {
      let mapped = [], gross = 0;
      let total_ctc = 0, take_home = 0;
      mapped = employeeSalaryIncrement.emp_oldpfctc.map(item => ({
        pf_eligible: item.pf_eligible,
        pf_slab: item.pf_slab,
        esi_eligible: item.esi_eligible,
        esi_slab: item.esi_slab || 0,
        employer_pf_percent: item.employer_pf_percent || 0,
        employee_pf_percent: item.employee_pf_percent || 0,
        employer_esi_percent: item.employer_esi_percent || 0,
        employee_esi_percent: item.employee_esi_percent || 0,
        employee_esi_amount: item.employee_esi_amount || 0,
        employer_pf_amount: item.employer_pf_amount || 0,
        employee_pf_amount: item.employee_pf_amount || 0
      }));

      gross = employeeSalaryIncrement?.emp_oldctc?.reduce((sum, item) => { const perMonth = parseFloat(item.per_month) || 0; return sum + perMonth; }, 0);
      formik.setFieldValue("employer_pf_percent", mapped[0]?.employer_pf_percent);
      formik.setFieldValue("employee_pf_percent", mapped[0]?.employee_pf_percent);
      formik.setFieldValue("employer_pf_amount", mapped[0]?.employer_pf_amount);
      formik.setFieldValue("employee_pf_amount", mapped[0]?.employee_pf_amount);

      total_ctc = gross + (parseFloat(mapped[0]?.employer_pf_amount) + parseFloat(mapped[0]?.employee_esi_amount));
      take_home = Number(gross) - (Number(mapped[0]?.employer_pf_amount) + Number(mapped[0]?.employee_esi_amount));

      formik.setFieldValue("employee_esi_percent", mapped[0]?.employee_esi_percent);
      formik.setFieldValue("employer_esi_percent", mapped[0]?.employer_esi_percent);
      formik.setFieldValue("employee_esi_amount", mapped[0]?.employee_esi_amount);
      formik.setFieldValue("employee_esi_amount", mapped[0]?.employee_esi_amount);
      formik.setFieldValue("total_ctc", total_ctc);
      formik.setFieldValue("take_home", take_home);
      setoldpfct(mapped[0]);
    }
  }, [employeeSalaryIncrement]);

  const handleNewCtcCalculation = (incrementValue) => {
    if (!emp_oldctc?.length || !emp_newctc?.length) return;
    const incValue = parseFloat(incrementValue || 0);
    const gross = (emp_oldctc || []).reduce((sum, item) => sum + parseFloat(item.per_month || 0), 0);
    const updatedAllowances = emp_newctc.map((item, index) => {

      const percentage = parseFloat(item.percentage || 0);
      const oldPerMonth = parseFloat(emp_oldctc[index]?.per_month || 0);
      const newPerMonth = newCtcMode === "percentage" ? (percentage * (gross + incValue)) / 100 : 0;

      return {
        ...item,
        per_month: newPerMonth.toFixed(0),
        per_year: (newPerMonth * 12).toFixed(0),
      };
    });


    const pfEligibleSalary = updatedAllowances.filter((item) => item.is_pf === "1").reduce((sum, item) => sum + parseFloat(item.per_month || 0), 0);
    const esiEligibleSalary = updatedAllowances.filter((item) => item.is_esi === "1").reduce((sum, item) => sum + parseFloat(item.per_month || 0), 0);
    const pfData = employeeSalaryIncrement?.emp_newpfctc?.[0];
    const newgross = (updatedAllowances || []).reduce((sum, item) => sum + parseFloat(item.per_month || 0), 0);
    const pfPercent = parseFloat(pfData?.employee_pf_percent || 0);
    const employerPfPercent = parseFloat(pfData?.employer_pf_percent || 0);
    const pfSlab = parseFloat(pfData?.pf_slab || 0);

    const grossch = Number(newgross) - (Number(incValue) + Number(gross));
    setgrosscheck(grossch)
    const esiPercent = parseFloat(pfData?.employee_esi_percent || 0);
    const employerEsiPercent = parseFloat(pfData?.employer_esi_percent || 0);
    const esiSlab = parseFloat(pfData?.esi_slab || 0);

    const pfBase = pfEligibleSalary > pfSlab ? pfSlab : pfEligibleSalary;

    const employeePF = Math.ceil((pfBase * pfPercent) / 100);
    const employerPF = Math.ceil((pfBase * employerPfPercent) / 100);

    let employeeESI = 0;
    let employerESI = 0;

    if (esiEligibleSalary <= esiSlab) {
      employeeESI = Math.ceil((esiEligibleSalary * esiPercent) / 100);
      employerESI = Math.ceil((esiEligibleSalary * employerEsiPercent) / 100);
    }
    const totalCTC = newgross + employerPF + employerESI;
    const takeHome = newgross - employeePF - employeeESI;

    formik.setFieldValue("new_employee_pf_percent", pfPercent);
    formik.setFieldValue("new_employer_pf_percent", employerPfPercent);
    formik.setFieldValue("new_employee_esi_percent", esiPercent);
    formik.setFieldValue("new_employer_esi_percent", employerEsiPercent);
    formik.setFieldValue("new_employee_pf_amount", employeePF.toFixed(2));
    formik.setFieldValue("new_employer_pf_amount", employerPF.toFixed(2));
    formik.setFieldValue("new_employee_esi_amount", employeeESI.toFixed(2));
    formik.setFieldValue("new_employer_esi_amount", employerESI.toFixed(2));
    formik.setFieldValue("new_total_ctc", totalCTC.toFixed(2));
    formik.setFieldValue("new_take_home", takeHome.toFixed(2));

    setEmpNewCtc(updatedAllowances);
  };

  const calculateManualPFESI = (updatedAllowances) => {
    const gross = updatedAllowances.reduce((sum, item) => sum + parseFloat(item.per_month || 0), 0);
    const pfEligibleSalary = updatedAllowances.filter(item => item.is_pf === "1").reduce((sum, item) => sum + parseFloat(item.per_month || 0), 0);
    const esiEligibleSalary = updatedAllowances.filter(item => item.is_esi === "1").reduce((sum, item) => sum + parseFloat(item.per_month || 0), 0);
    const pfData = employeeSalaryIncrement?.emp_newpfctc?.[0];

    const pfPercent = parseFloat(pfData?.employee_pf_percent || 0);
    const employerPfPercent = parseFloat(pfData?.employer_pf_percent || 0);
    const pfSlab = parseFloat(pfData?.pf_slab || 0);

    const esiPercent = parseFloat(pfData?.employee_esi_percent || 0);
    const employerEsiPercent = parseFloat(pfData?.employer_esi_percent || 0);
    const esiSlab = parseFloat(pfData?.esi_slab || 0);

    const pfBase = pfEligibleSalary > pfSlab ? pfSlab : pfEligibleSalary;

    const employeePF = (pfBase * pfPercent) / 100;
    const employerPF = (pfBase * employerPfPercent) / 100;

    let employeeESI = 0;
    let employerESI = 0;

    if (esiEligibleSalary <= esiSlab) {
      employeeESI = (esiEligibleSalary * esiPercent) / 100;
      employerESI = (esiEligibleSalary * employerEsiPercent) / 100;
    }
    const totalCTC = gross + employerPF + employerESI;
    const takeHome = gross - employeePF - employeeESI;

    formik.setFieldValue("new_employee_pf_amount", employeePF.toFixed(2));
    formik.setFieldValue("new_employer_pf_amount", employerPF.toFixed(2));
    formik.setFieldValue("new_employee_esi_amount", employeeESI.toFixed(2));
    formik.setFieldValue("new_employer_esi_amount", employerESI.toFixed(2));
    formik.setFieldValue("new_employee_pf_percent", pfPercent);
    formik.setFieldValue("new_employer_pf_percent", employerPfPercent);
    formik.setFieldValue("new_employee_esi_percent", esiPercent);
    formik.setFieldValue("new_employer_esi_percent", employerEsiPercent);
    formik.setFieldValue("new_total_ctc", totalCTC.toFixed(2));
    formik.setFieldValue("new_take_home", takeHome.toFixed(2));
  };

  const calculateWithGivenData = (baseData, incrementValue) => {
    if (!emp_oldctc?.length || !baseData?.length) return;

    const incValue = parseFloat(incrementValue || 0);

    const updatedAllowances = baseData.map((item, index) => {
      const percentage = parseFloat(item.percentage || 0);
      const oldPerMonth = parseFloat(emp_oldctc[index]?.per_month || 0);

      const newPerMonth =
        oldPerMonth + (percentage * incValue) / 100;

      return {
        ...item,
        per_month: newPerMonth.toFixed(2),
        per_year: (newPerMonth * 12).toFixed(2),
      };
    });

    // reuse your existing PF/ESI logic
    calculateManualPFESI(updatedAllowances);

    setEmpNewCtc(updatedAllowances);
  };

  const handleModeChange = (newMode) => {
    setNewCtcMode(newMode);

    // reset calculated fields only
    formik.setFieldValue("new_employee_pf_amount", "");
    formik.setFieldValue("new_employer_pf_amount", "");
    formik.setFieldValue("new_employee_esi_amount", "");
    formik.setFieldValue("new_employer_esi_amount", "");
    formik.setFieldValue("new_total_ctc", "");
    formik.setFieldValue("new_take_home", "");

    if (newMode === "percentage") {
      if (employeeSalaryIncrement?.emp_newctc?.length > 0) {
        const freshData = employeeSalaryIncrement.emp_newctc;

        // set first
        setEmpNewCtc(freshData);

        // calculate using fresh data (NOT state)
        if (formik.values.increment_amount) {
          calculateWithGivenData(freshData, formik.values.increment_amount);
        }
      }
    } else if (newMode === "manual") {
      const resetList = emp_newctc.map(item => ({
        ...item,
        percentage: "0.00",
        per_month: "0.00",
        per_year: "0.00"
      }));

      setEmpNewCtc(resetList);
      calculateManualPFESI(resetList);
    }
  };

  const resetFormData = () => {
    formik.resetForm();
    setEmployeeDataSelected(null);
    setMonth(null);
    setShowFromDetails(false);
    setemp_oldctc([]);
    setEmpNewCtc([]);
    setFinancialYearRange({ start: null, end: null });
    setNewCtcMode("percentage");
    const fieldsToClear = [
      "increment_amount",
      "employee_esi_percent",
      "employer_esi_percent",
      "employee_esi_amount",
      "employer_esi_amount",
      "employee_pf_percent",
      "employer_pf_percent",
      "employee_pf_amount",
      "employer_pf_amount",
      "total_ctc",
      "take_home",
      "new_employee_esi_percent",
      "new_employer_esi_amount",
      "new_employee_pf_percent",
      "new_employer_pf_percent",
      "new_employee_pf_amount",
      "new_employer_pf_amount",
      "new_employee_esi_amount",
      "new_total_ctc",
      "new_take_home"
    ];
    fieldsToClear.forEach(field => {
      formik.setFieldValue(field, "");
    });

  };

  useEffect(() => {
    return () => {
      dispatch(clearapproveError());
    };
  }, []);


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Payroll / Increment" breadcrumbItem="Increment Update" />
          <Form onSubmit={formik.handleSubmit}>
            <Card>
              <CardBody>
                <div className="">
                  <Accordion open={open} toggle={toggle} className="accordion-body p-2">
                    {/* Add Form Accordion */}
                    <AccordionItem>
                      <AccordionHeader targetId="1" className="bg-primary text-white" >
                        Add
                      </AccordionHeader>
                      <AccordionBody accordionId="1">
                        <div className="container-fluid mt-3">
                          <div className="card shadow-sm">
                            <div className="card-body">
                              <div className="row g-3">
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="form-label">Employee <span className="text-danger">*</span></label>
                                    <FormGroup>
                                      <CustomSelect
                                        id="employee"
                                        name="employee"
                                        isMulti={false}
                                        options={employees}
                                        value={employeeDataSelected}
                                        onChange={(selectedOption) => {
                                          setEmployeeDataSelected(selectedOption);
                                          formik.setFieldValue("employee", selectedOption);
                                          findEmpSalaryIncrement(selectedOption);
                                          handleEmployeeChange(selectedOption);
                                        }}
                                        onBlur={() => formik.setFieldTouched("employee", true)}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        isClearable={true}
                                      />
                                      {formik.touched.employee && formik.errors.employee && (
                                        <div className="text-danger"> {formik.errors.employee} </div>
                                      )}
                                    </FormGroup>
                                  </div>
                                  <div className="mb-3">
                                    <label className="form-label">Financial Month <span className="text-danger">*</span></label>
                                    <CustomMonthPicker
                                      name="financialMonth"
                                      value={formik.values.financialMonth}
                                      onChange={(date) => formik.setFieldValue("financialMonth", date)}
                                      onBlur={() => formik.setFieldTouched("financialMonth", true)}
                                      minDate={financialYearRange.start}
                                      maxDate={financialYearRange.end}
                                      disableFuture={true}
                                      className="form-control form-control-sm"
                                      classNamePrefix="react-select"
                                      isClearable={true}
                                    />
                                    {formik.touched.financialMonth && formik.errors.financialMonth && (
                                      <div className="text-danger mt-1">{formik.errors.financialMonth}</div>
                                    )}
                                  </div>
                                  {showFromDetails && (
                                    <>
                                      <div className="mb-3">
                                        <label className="form-label">From Category</label>
                                        <FormGroup>
                                          <Input type="text" id="from_category" value={emp_personnel?.emp_category || null} disabled />
                                        </FormGroup>
                                      </div>
                                      <div className="mb-3">
                                        <label className="form-label">From Department</label>
                                        <FormGroup>
                                          <Input type="text" id="from_department" value={emp_personnel?.department_name || ""} disabled />
                                        </FormGroup>
                                      </div>
                                      <div className="mb-3">
                                        <label className="form-label">From Designation</label>
                                        <FormGroup>
                                          <Input type="text" id="from_designation" value={emp_personnel?.designation || ""} disabled />
                                        </FormGroup>
                                      </div>
                                      <div className="mb-3">
                                        <label className="form-label">Employement Type</label>
                                        <FormGroup>
                                          <Input type="text" id="from_employementtype" value={emp_personnel?.emp_type || ""} disabled />
                                        </FormGroup>
                                      </div>
                                    </>
                                  )}

                                  <div className="mb-3">
                                    <label className="form-label">Increment Amount <span className="text-danger">*</span></label>
                                    <Input
                                      type="number"
                                      id="increment_amount"
                                      name="increment_amount"
                                      className="form-control form-control-sm"
                                      value={formik.values.increment_amount || ""}
                                      onKeyDown={(e) => {
                                        if (["-", "+", "*", "/", "e", "E", "."].includes(e.key)) {
                                          e.preventDefault();
                                        }
                                      }}

                                      onInput={(e) => {
                                        const value = e.target.value.replace(/[^0-9]/g, "");
                                        formik.setFieldValue("increment_amount", value);
                                        handleNewCtcCalculation(value);
                                      }}
                                    />
                                    {formik.touched.increment_amount && formik.errors.increment_amount && (
                                      <div className="text-danger mt-1">{formik.errors.increment_amount}</div>
                                    )}
                                  </div>
                                  <div className="mb-3">
                                    <label className="form-label">Inc Date <span className="text-danger">*</span></label>
                                    <CustomDatePicker
                                      name="month"
                                      id="month"
                                      value={formik.values.month}
                                      onChange={(date) => { formik.setFieldValue("month", date); }}
                                      onBlur={() => { console.log("Blurred! Value is:", month); }}
                                      // minDate={financialYearRange.start}
                                      // maxDate={financialYearRange.end}
                                      disableFuture={true}
                                      className="form-control form-control-sm"
                                      classNamePrefix="react-select"
                                      isClearable={true}
                                    />
                                    {formik.touched.month && formik.errors.month && (
                                      <div className="text-danger mt-1">{formik.errors.month}</div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="form-label">Financial Year <span className="text-danger">*</span></label>
                                    <CustomSelect
                                      id="finyear"
                                      name="finyear"
                                      isMulti={false}
                                      options={
                                        finacial_types?.finacial_year?.map((fy) => ({
                                          value: fy.fy_id, label: fy.fin_year, fin_year: fy.fin_year
                                        })) || []
                                      }
                                      value={formik.values.finyear || null}
                                      onChange={(selectedOption) => {
                                        formik.setFieldValue("finyear", selectedOption);
                                        const range = getFinancialYearRange(selectedOption?.fin_year);
                                        setFinancialYearRange(range);
                                        formik.setFieldValue("month", null);
                                        formik.setFieldValue("financialMonth", null);
                                        setMonth(null);
                                      }}
                                      onBlur={() => formik.setFieldTouched("finyear", true)}
                                    />
                                    {formik.touched.finyear && formik.errors.finyear && (
                                      <div className="text-danger mt-1">{formik.errors.finyear}</div>
                                    )}
                                  </div>
                                  <div className="mb-3">
                                    <label className="form-label">Increment Type <span className="text-danger">*</span></label>
                                    <CustomSelect
                                      id="increment_types"
                                      name="increment_types"
                                      isMulti={false}
                                      options={increment_type || []}
                                      value={formik.values.increment_types}
                                      onChange={(selectedOption) => {
                                        formik.setFieldValue("increment_types", selectedOption);
                                        if (!selectedOption) {
                                          formik.setFieldValue("category", null);
                                          formik.setFieldValue("department", null);
                                          formik.setFieldValue("designation", null);
                                          setShowFromDetails(false);
                                          setEmpNewCtc([]);
                                        } else {
                                          ShowDetails(selectedOption);
                                        }
                                      }}
                                      onBlur={() => formik.setFieldTouched("increment_types", true)}
                                      className="react-select-container"
                                      classNamePrefix="react-select"
                                      isClearable={true}
                                    />
                                    {formik.touched.increment_types && formik.errors.increment_types && (
                                      <div className="text-danger mt-1">{formik.errors.increment_types}</div>
                                    )}
                                  </div>
                                  {showFromDetails && (
                                    <>
                                      <div className="mb-3">
                                        <label className="form-label">To Category</label>
                                        <FormGroup>
                                          <CustomSelect
                                            id="category"
                                            name="category"
                                            isMulti={false}
                                            options={categoryOptions || []}
                                            value={formik.values.category || null}
                                            onChange={(selectedOption) => {
                                              formik.setFieldValue("category", selectedOption);
                                              if (selectedOption && employeeDataSelected) {
                                                findEmpSalaryIncrement(employeeDataSelected, selectedOption.value);
                                              }
                                            }}
                                            onBlur={() => formik.setFieldTouched("category", true)}
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            isClearable={true}
                                          />
                                          {formik.touched.category && formik.errors.category && (
                                            <div className="text-danger"> {formik.errors.category}</div>
                                          )}
                                        </FormGroup>
                                      </div>
                                      <div className="mb-3">
                                        <label className="form-label">To Department</label>
                                        <FormGroup>
                                          <CustomSelect
                                            id="department"
                                            name="department"
                                            isMulti={false}
                                            options={deptOptions || []}
                                            value={formik.values.department || null}
                                            onChange={(selectedOption) => { formik.setFieldValue("department", selectedOption); }}
                                            onBlur={() => formik.setFieldTouched("department", true)}
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            isClearable={true}
                                          />

                                          {formik.touched.department && formik.errors.department && (
                                            <div className="text-danger">{formik.errors.department}</div>
                                          )}
                                        </FormGroup>
                                      </div>
                                      <div className="mb-3">
                                        <label className="form-label">To Designation</label>
                                        <FormGroup>
                                          <CustomSelect
                                            id="designation"
                                            name="designation"
                                            isMulti={false}
                                            options={desigOption || []}
                                            value={formik.values.designation || null}
                                            onChange={(selectedOption) => { formik.setFieldValue("designation", selectedOption); }}
                                            onBlur={() => formik.setFieldTouched("designation", true)}
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            isClearable={true}
                                          />
                                          {formik.touched.designation && formik.errors.designation && (
                                            <div className="text-danger">{formik.errors.designation}</div>
                                          )}
                                        </FormGroup>
                                      </div>
                                      <div className="mb-3">
                                        <label className="form-label">To Employement Type</label>
                                        <FormGroup>
                                          <CustomSelect
                                            id="toemptype"
                                            name="toemptype"
                                            isMulti={false}
                                            options={emptypeoption || []}
                                            value={formik.values.toemptype || null}
                                            onChange={(selectedOption) => { formik.setFieldValue("toemptype", selectedOption); }}
                                            onBlur={() => formik.setFieldTouched("toemptype", true)}
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            isClearable={true}
                                          />
                                          {formik.touched.toemptype && formik.errors.toemptype && (
                                            <div className="text-danger">{formik.errors.toemptype}</div>
                                          )}
                                        </FormGroup>
                                      </div>
                                    </>
                                  )}
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Remarks
                                      {showFromDetails && <span className="text-danger"> *</span>}

                                    </label>
                                    {/* <label className="form-label">Remarks</label> */}
                                    <input type="text" name="remarks" className="form-control form-control-sm" value={formik.values.remarks}
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.remarks && formik.errors.remarks && (
                                      <div className="text-danger">{formik.errors.remarks}</div>
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className="text-end mt-4">
                                <button className="btn button-save me-2"> <i className="fas fa-save me-1" />Submit</button>
                                <Button type="reset" className="btn button-cancel"
                                  onClick={() => {
                                    Swal.fire({
                                      title: "Are you sure?", text: "Unsaved clear will be lost!", icon: "warning",
                                      showCancelButton: true, confirmButtonText: "Yes, Clear", cancelButtonText: "No", confirmButtonColor: "#3085d6", cancelButtonColor: "#d33"
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        //  formik.resetForm 
                                        resetFormData();
                                      }
                                    });
                                  }}
                                >
                                  <i className="fas fa-sync me-1" /> Cancel
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* OLD CTC */}
                        <div className="row mt-4">
                          <div className="col-md-6">
                            <div className="card shadow-sm">
                              <div className="card-header bg-primary fw-bold text-white">OLD CTC</div>
                              <Row>
                                <Col md={6}>
                                  {emp_oldctc?.length > 0 && (
                                    <div className="card-body p-3">
                                      {/* Dynamic Rows */}
                                      {emp_oldctc.map((item, index) => (
                                        <div className="row mb-2" key={index}>
                                          <div className="col-4">{item.allowance}</div>
                                          <div className="col-3">
                                            <input
                                              type="text"
                                              id={`percentage1_${index}`}
                                              className="form-control form-control"
                                              value={item.percentage}
                                              disabled
                                              onChange={(e) => {
                                                const newList = [...emp_newctc];
                                                newList[index].percentage = e.target.value;
                                                setEmpNewCtc(newList);
                                              }}
                                            />
                                            <UncontrolledTooltip placement="top" target={`percentage1_${index}`}>
                                              {item.percentage || "0.00"}
                                            </UncontrolledTooltip>
                                          </div>
                                          <div className="col-5">
                                            <input
                                              id={`per_month1_${index}`}
                                              type="text"
                                              className="form-control form-control-sm text-end"
                                              value={item.per_month}
                                              onChange={(e) => {
                                                if (newCtcMode === "manual") {
                                                  const val = e.target.value;
                                                  const newList = [...emp_newctc];
                                                  newList[index].per_month = val;
                                                  setEmpNewCtc(newList);
                                                }
                                              }}
                                              disabled
                                            />
                                            <UncontrolledTooltip placement="top" target={`per_month1_${index}`}>
                                              {item.per_month || "0.00"}
                                            </UncontrolledTooltip>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                  <hr />
                                  <div className="card-body p-3">
                                    <div className="row fw-bold bg-light p-2 rounded">
                                      <div className="col-6">GROSS</div>
                                      <div className="col-6 text-end">
                                        {(emp_oldctc ?? []).reduce((sum, item) => sum + Number(item.per_month), 0).toFixed(2)}
                                      </div>
                                    </div>
                                  </div>

                                </Col>
                                <Col md={6}>
                                  <div className="card-body p-4">
                                    <FormGroup row>
                                      <Col md={4}>
                                        <Label>Employer ESI</Label>
                                      </Col>
                                      <Col md={3}>
                                        <Input
                                          type="text"
                                          id="employee_esi_percent1"
                                          name="employee_esi_percent"
                                          disabled
                                          value={formik.values.employee_esi_percent}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("employee_esi_percent", val); }}
                                          onBlur={formik.handleBlur}
                                          className={`text-end ${formik.errors.employee_esi_percent && formik.touched.employee_esi_percent ? "is-invalid" : ""}`}
                                        />
                                        <UncontrolledTooltip placement="top" target="employee_esi_percent1">
                                          {formik.values.employee_esi_percent || "0.00"}
                                        </UncontrolledTooltip>
                                        {formik.errors.employee_esi_percent && formik.touched.employee_esi_percent && (
                                          <div className="text-danger">{formik.errors.employee_esi_percent}</div>
                                        )}
                                      </Col>
                                      <Col md={5}>
                                        <Input
                                          type="text"
                                          id="employee_esi_percent1"
                                          name="employer_esi_amount"
                                          disabled
                                          value={formik.values.employee_esi_percent}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("employer_esi_amount", val); }}
                                          onBlur={formik.handleBlur}
                                          className={`text-end ${formik.errors.employee_esi_percent && formik.touched.employer_esi_amount ? "is-invalid" : ""}`}
                                        />
                                        <UncontrolledTooltip placement="top" target="employee_esi_percent1">
                                          {formik.values.employee_esi_percent || "0.00"}
                                        </UncontrolledTooltip>
                                        {formik.errors.employer_esi_amount && formik.touched.employer_esi_amount && (
                                          <div className="text-danger">{formik.errors.employer_esi_amount}</div>
                                        )}
                                      </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                      <Col md={4}>
                                        <Label>Employer PF</Label>
                                      </Col>
                                      <Col md={3}>
                                        <Input
                                          type="text"
                                          id="employer_pf_percent1"
                                          name="employer_pf_percent"
                                          disabled
                                          value={formik.values.employer_pf_percent}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("employer_pf_percent", val); }}
                                          onBlur={formik.handleBlur}
                                          className={`text-end ${formik.errors.employer_pf_percent && formik.touched.employer_pf_percent ? "is-invalid" : ""}`}
                                        />
                                        <UncontrolledTooltip placement="top" target="employer_pf_percent1">
                                          {formik.values.employer_pf_percent || "0.00"}
                                        </UncontrolledTooltip>
                                        {formik.errors.employer_pf_percent && formik.touched.employer_pf_percent && (
                                          <div className="text-danger">{formik.errors.employer_pf_percent}</div>
                                        )}
                                      </Col>
                                      <Col md={5}>
                                        <Input
                                          type="text"
                                          id="employer_pf_amount1"
                                          name="employer_pf_amount"
                                          disabled
                                          value={formik.values.employer_pf_amount}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("employer_pf_amount", val); }}
                                          onBlur={formik.handleBlur}
                                          className={`text-end ${formik.errors.employer_pf_amount && formik.touched.employer_pf_amount ? "is-invalid" : ""}`}
                                        />
                                        <UncontrolledTooltip placement="top" target="employer_pf_amount1">
                                          {formik.values.employer_pf_amount || "0.00"}
                                        </UncontrolledTooltip>
                                        {formik.errors.employer_pf_amount && formik.touched.employer_pf_amount && (
                                          <div className="text-danger">{formik.errors.employer_pf_amount}</div>
                                        )}
                                      </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                      <Col md={5}>
                                        <Label className="row fw-bold bg-light p-2 rounded">TOTAL CTC</Label>
                                      </Col>
                                      <Col md={7}>
                                        <Input
                                          type="text"
                                          name="total_ctc"
                                          disabled
                                          value={formik.values.total_ctc}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("total_ctc", val); }}
                                          onBlur={formik.handleBlur}
                                          className={`text-end ${formik.errors.total_ctc && formik.touched.total_ctc ? "is-invalid" : ""}`}
                                        />
                                        {formik.errors.total_ctc && formik.touched.total_ctc && (<div className="text-danger">{formik.errors.total_ctc}</div>)}
                                      </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                      <Col md={4}>
                                        <Label>Employee ESI</Label>
                                      </Col>
                                      <Col md={3}>
                                        <Input
                                          type="text"
                                          id="employee_esi_percent1"
                                          name="employee_esi_percent"
                                          disabled
                                          value={formik.values.employee_esi_percent}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("employee_esi_percent", val); }}
                                          onBlur={formik.handleBlur}
                                          className={`text-end ${formik.errors.employee_esi_percent && formik.touched.employee_esi_percent ? "is-invalid" : ""}`}
                                        />
                                        <UncontrolledTooltip placement="top" target="employee_esi_percent1">
                                          {formik.values.employee_esi_percent || "0.00"}
                                        </UncontrolledTooltip>
                                        {formik.errors.employee_esi_percent && formik.touched.employee_esi_percent && (
                                          <div className="text-danger">{formik.errors.employee_esi_percent}</div>
                                        )}

                                      </Col>
                                      <Col md={5}>
                                        <Input
                                          type="text"
                                          id="employee_esi_amount1"
                                          name="employee_esi_amount"
                                          disabled
                                          value={formik.values.employee_esi_amount}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("employee_esi_amount", val); }}
                                          onBlur={formik.handleBlur}
                                          className={`text-end ${formik.errors.employee_esi_amount && formik.touched.employee_esi_amount ? "is-invalid" : ""}`}
                                        />
                                        <UncontrolledTooltip placement="top" target="employee_esi_amount1">
                                          {formik.values.employee_esi_amount || "0.00"}
                                        </UncontrolledTooltip>
                                        {formik.errors.employee_esi_amount && formik.touched.employee_esi_amount && (
                                          <div className="text-danger">{formik.errors.employee_esi_amount}</div>
                                        )}

                                      </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                      <Col md={4}>
                                        <Label>Employee PF</Label>
                                      </Col>
                                      <Col md={3}>
                                        <Input
                                          type="text"
                                          id="employee_pf_percent1"
                                          name="employee_pf_percent"
                                          disabled
                                          value={formik.values.employee_pf_percent}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("employee_pf_percent", val); }}
                                          onBlur={formik.handleBlur}
                                          className={`text-end ${formik.errors.employee_pf_percent && formik.touched.employee_pf_percent ? "is-invalid" : ""}`}
                                        />
                                        <UncontrolledTooltip placement="top" target="employee_pf_percent1">
                                          {formik.values.employee_pf_percent || "0.00"}
                                        </UncontrolledTooltip>
                                        {formik.errors.employee_pf_percent && formik.touched.employee_pf_percent && (
                                          <div className="text-danger">{formik.errors.employee_pf_percent}</div>
                                        )}

                                      </Col>
                                      <Col md={5}>
                                        <Input
                                          type="text"
                                          id="employee_pf_amount1"
                                          name="employee_pf_amount"
                                          disabled
                                          value={formik.values.employee_pf_amount}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("employee_pf_amount", val); }}
                                          onBlur={formik.handleBlur}
                                          className={`text-end ${formik.errors.employee_pf_amount && formik.touched.employee_pf_amount ? "is-invalid" : ""}`}
                                        />
                                        <UncontrolledTooltip placement="top" target="employee_pf_amount1">
                                          {formik.values.employee_pf_amount || "0.00"}
                                        </UncontrolledTooltip>
                                        {formik.errors.employee_pf_amount && formik.touched.employee_pf_amount && (
                                          <div className="text-danger">{formik.errors.employee_pf_amount}</div>
                                        )}
                                      </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                      <Col md={5}>
                                        <Label className="row fw-bold bg-light p-2 rounded">TAKE HOME</Label>
                                      </Col>
                                      <Col md={7}>
                                        <Input
                                          type="text"
                                          name="take_home"
                                          disabled={true}
                                          value={formik.values.take_home}
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                          className={`text-end ${formik.errors.take_home && formik.touched.take_home ? "is-invalid" : ""}`}
                                        />
                                      </Col>
                                    </FormGroup>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </div>

                          {/* <!-- NEW CTC --> */}
                          <div className="col-md-6">
                            <div className="card shadow-sm border-success">
                              <div className="card-header bg-success text-white fw-bold">NEW CTC</div>
                              <Row>
                                <Col md={6}>
                                  <div className="mt-2 ms-2">
                                    <Label className="me-3">
                                      <Input type="radio" name="newCtcMode" value="percentage" checked={newCtcMode === "percentage"}
                                        onChange={(e) => handleModeChange(e.target.value)} />
                                      {" "}
                                      Percentage
                                    </Label>

                                    <Label>
                                      <Input type="radio" name="newCtcMode" value="manual" checked={newCtcMode === "manual"}
                                        onChange={(e) => handleModeChange(e.target.value)}
                                      />{" "}
                                      Manual
                                    </Label>
                                  </div>
                                  <div className="card-body p-0">
                                    {emp_newctc?.length > 0 && (
                                      <div className="card-body p-3">
                                        {/* Dynamic Rows */}
                                        {emp_newctc.map((item, index) => (
                                          <div className="row mb-2" key={index}>
                                            <div className={newCtcMode === "manual" ? "col-6" : "col-4"}>
                                              {item.allowance}
                                            </div>
                                            {newCtcMode === "percentage" && (
                                              <div className="col-3">
                                                <input type="text" className="form-control" id={`percentage_${index}`} value={item.percentage} disabled />
                                                <UncontrolledTooltip placement="top" target={`percentage_${index}`}>
                                                  {item.percentage}
                                                </UncontrolledTooltip>
                                              </div>
                                            )}
                                            <div className={newCtcMode === "percentage" ? "col-5" : "col-6"}>
                                              <input
                                                type="text"
                                                id={`per_month_${index}`}
                                                className="form-control form-control-sm text-end"
                                                value={item.per_month || ""}
                                                disabled={newCtcMode === "percentage"}
                                                onKeyDown={(e) => {
                                                  if (["-", "+", "*", "/", "e", "E", "."].includes(e.key)) {
                                                    e.preventDefault();
                                                  }
                                                }}
                                                onChange={(e) => {
                                                  if (newCtcMode === "manual") {
                                                    const val = e.target.value.replace(/[^0-9]/g, "");
                                                    const updated = [...emp_newctc];
                                                    updated[index].per_month = val;
                                                    updated[index].per_year = (parseFloat(val || 0) * 12).toFixed(2);
                                                    setEmpNewCtc(updated);
                                                    // Recalculate PF & ESI after manual edit
                                                    calculateManualPFESI(updated);
                                                  }
                                                }}
                                              />
                                              <UncontrolledTooltip placement="top" target={`per_month_${index}`}>
                                                {item.per_month}
                                              </UncontrolledTooltip>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                    <hr />

                                    <div className="row fw-bold bg-light p-2 rounded ms-2 me-2">
                                      <div className="col-6">GROSS</div>
                                      <div className="col-6 text-end">
                                        {(emp_newctc ?? []).reduce((sum, item) => sum + Number(item.per_month || 0), 0).toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <div className="card-body p-4 mt-4">
                                    <FormGroup row>
                                      <Col md={4}>
                                        <Label>Employer ESI</Label>
                                      </Col>
                                      <Col md={3}>
                                        <Input
                                          type="text"
                                          name="new_employer_esi_percent"
                                          id="employer_pf_percent"
                                          value={formik.values.new_employer_esi_percent || 0.00}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("new_employer_esi_percent", val); }}
                                          onBlur={formik.handleBlur}
                                          disabled
                                          className={`text-end ${formik.errors.new_employer_esi_percent && formik.touched.new_employer_esi_percent ? "is-invalid" : ""}`}
                                        />
                                        <UncontrolledTooltip placement="top" target="employer_pf_percent">
                                          {formik.values.new_employer_esi_percent || 0.00}
                                        </UncontrolledTooltip>
                                        {formik.errors.new_employer_esi_percent && formik.touched.new_employer_esi_percent && (
                                          <div className="text-danger">{formik.errors.new_employer_esi_percent}</div>
                                        )}
                                      </Col>
                                      <Col md={5}>
                                        <Input
                                          type="text"
                                          id="new_employer_esi_amount"
                                          name="new_employer_esi_amount"
                                          value={formik.values.new_employer_esi_amount || 0.00}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("new_employer_esi_amount", val); }}
                                          onBlur={formik.handleBlur}
                                          disabled
                                          className={`text-end ${formik.errors.new_employer_esi_amount && formik.touched.new_employer_esi_amount ? "is-invalid" : ""}`}
                                        />
                                        <UncontrolledTooltip placement="top" target="new_employer_esi_amount">
                                          {formik.values.new_employer_esi_amount || 0.00}
                                        </UncontrolledTooltip>
                                        {formik.errors.new_employer_esi_amount && formik.touched.new_employer_esi_amount && (
                                          <div className="text-danger">{formik.errors.new_employer_esi_amount}</div>
                                        )}
                                      </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                      <Col md={4}>
                                        <Label>Employer PF</Label>
                                      </Col>
                                      <Col md={3}>
                                        <Input
                                          type="text"
                                          id="new_employer_pf_percent"
                                          name="new_employer_pf_percent"
                                          value={formik.values.new_employer_pf_percent || 0.00}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("new_employer_pf_percent", val); }}
                                          onBlur={formik.handleBlur}
                                          disabled
                                          className={`text-end ${formik.errors.new_employer_pf_percent && formik.touched.new_employer_pf_percent ? "is-invalid" : ""}`}
                                        />
                                        <UncontrolledTooltip placement="top" target="new_employer_pf_percent">
                                          {formik.values.new_employer_pf_percent || "0.00"}
                                        </UncontrolledTooltip>
                                        {formik.errors.new_employer_pf_percent && formik.touched.new_employer_pf_percent && (
                                          <div className="text-danger">{formik.errors.new_employer_pf_percent}</div>
                                        )}
                                      </Col>
                                      <Col md={5}>
                                        <Input
                                          type="text"
                                          id="new_employer_pf_amount"
                                          name="new_employer_pf_amount"
                                          value={formik.values.new_employer_pf_amount || 0.00}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("new_employer_pf_amount", val); }}
                                          onBlur={formik.handleBlur}
                                          disabled
                                          className={`text-end ${formik.errors.new_employer_pf_amount && formik.touched.new_employer_pf_amount ? "is-invalid" : ""}`}
                                        />
                                        <UncontrolledTooltip placement="top" target="new_employer_pf_amount">
                                          {formik.values.employer_pf_amount || "0.00"}
                                        </UncontrolledTooltip>
                                        {formik.errors.new_employer_pf_amount && formik.touched.new_employer_pf_amount && (
                                          <div className="text-danger">{formik.errors.new_employer_pf_amount}</div>
                                        )}
                                      </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                      <Col md={5}>
                                        <Label className="row fw-bold bg-light p-2 rounded">TOTAL CTC</Label>
                                      </Col>
                                      <Col md={7}>
                                        <Input
                                          type="text"
                                          name="new_total_ctc"
                                          value={formik.values.new_total_ctc}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("new_total_ctc", val); }}
                                          onBlur={formik.handleBlur}
                                          disabled
                                          className={`text-end ${formik.errors.new_total_ctc && formik.touched.new_total_ctc ? "is-invalid" : ""}`}
                                        />
                                        {formik.errors.total_ctc && formik.touched.new_total_ctc && (<div className="text-danger">{formik.errors.new_total_ctc}</div>)}
                                      </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                      <Col md={4}>
                                        <Label>Employee ESI</Label>
                                      </Col>
                                      <Col md={3}>
                                        <Input
                                          type="text"
                                          id="new_employee_esi_percent"
                                          name="new_employee_esi_percent"
                                          value={formik.values.new_employee_esi_percent || 0.00}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("new_employee_esi_percent", val); }}
                                          onBlur={formik.handleBlur}
                                          disabled
                                          className={`text-end ${formik.errors.new_employee_esi_percent && formik.touched.employee_esi_percent ? "is-invalid" : ""}`}
                                        />
                                        <UncontrolledTooltip placement="top" target="new_employee_esi_percent">
                                          {formik.values.new_employee_esi_percent || "0.00"}
                                        </UncontrolledTooltip>
                                        {formik.errors.new_employee_esi_percent && formik.touched.new_employee_esi_percent && (
                                          <div className="text-danger">{formik.errors.new_employee_esi_percent}</div>
                                        )}

                                      </Col>
                                      <Col md={5}>
                                        <Input
                                          type="text"
                                          id="new_employee_esi_amount"
                                          name="new_employee_esi_amount"
                                          value={formik.values.new_employee_esi_amount || 0.00}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("new_employee_esi_amount", val); }}
                                          onBlur={formik.handleBlur}
                                          disabled
                                          className={`text-end ${formik.errors.new_employee_esi_amount && formik.touched.new_employee_esi_amount ? "is-invalid" : ""}`}
                                        />
                                        <UncontrolledTooltip placement="top" target="new_employee_esi_amount">
                                          {formik.values.new_employee_esi_amount || "0.00"}
                                        </UncontrolledTooltip>
                                        {formik.errors.new_employee_esi_amount && formik.touched.new_employee_esi_amount && (
                                          <div className="text-danger">{formik.errors.new_employee_esi_amount}</div>
                                        )}

                                      </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                      <Col md={4}>
                                        <Label>Employee PF</Label>
                                      </Col>
                                      <Col md={3}>
                                        <Input
                                          type="text"
                                          id="new_employee_pf_percent"
                                          name="new_employee_pf_percent"
                                          value={formik.values.new_employee_pf_percent || 0.00}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("new_employee_pf_percent", val); }}
                                          onBlur={formik.handleBlur}
                                          disabled
                                          className={`text-end ${formik.errors.new_employee_pf_percent && formik.touched.new_employee_pf_percent ? "is-invalid" : ""}`}
                                        />
                                        <UncontrolledTooltip placement="top" target="new_employee_pf_percent">
                                          {formik.values.new_employee_pf_percent || "0.00"}
                                        </UncontrolledTooltip>
                                        {formik.errors.new_employee_pf_percent && formik.touched.new_employee_pf_percent && (
                                          <div className="text-danger">{formik.errors.new_employee_pf_percent}</div>
                                        )}

                                      </Col>
                                      <Col md={5}>
                                        <Input
                                          type="text"
                                          id="new_employee_pf_amount"
                                          name="new_employee_pf_amount"
                                          value={formik.values.new_employee_pf_amount || 0.00}
                                          onChange={(e) => { const val = e.target.value; formik.setFieldValue("new_employee_pf_amount", val); }}
                                          onBlur={formik.handleBlur}
                                          disabled
                                          className={`text-end ${formik.errors.new_employee_pf_amount && formik.touched.new_employee_pf_amount ? "is-invalid" : ""}`}
                                        />
                                        <UncontrolledTooltip placement="top" target="new_employee_pf_amount">
                                          {formik.values.new_employee_pf_amount || "0.00"}
                                        </UncontrolledTooltip>
                                        {formik.errors.new_employee_pf_amount && formik.touched.new_employee_pf_amount && (
                                          <div className="text-danger">{formik.errors.new_employee_pf_amount}</div>
                                        )}
                                      </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                      <Col md={5}>
                                        <Label className="row fw-bold bg-light p-2 rounded">TAKE HOME</Label>
                                      </Col>
                                      <Col md={7}>
                                        <Input
                                          type="text"
                                          name="new_take_home"
                                          value={formik.values.new_take_home}
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                          disabled
                                          className={`text-end ${formik.errors.new_take_home && formik.touched.new_take_home ? "is-invalid" : ""}`}
                                        />
                                      </Col>
                                    </FormGroup>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </AccordionBody>
                    </AccordionItem>

                    {/* Search Accordion */}
                    <AccordionItem>
                      <AccordionHeader targetId="2">Search</AccordionHeader>
                      <AccordionBody accordionId="2">
                        <Row className="mb-3">
                          <div className="col-md-4 mt-2">
                            <label>Financial Year </label>
                            <CustomSelect
                              id="finyear"
                              name="finyear"
                              isMulti={false}
                              options={finacial_types?.finacial_year?.map((fy) => ({ value: fy.fy_id, label: fy.fin_year, fin_year: fy.fin_year })) || []}
                              value={formik.values.finyear || null}
                              onChange={(selectedOption) => {
                                formik.setFieldValue("finyear", selectedOption);
                                const range = getFinancialYearRange(selectedOption?.fin_year);
                                setFinancialYearRange(range);
                                setMonth(null);
                              }}
                              onBlur={() => formik.setFieldTouched("finyear", true)}
                            />
                          </div>
                          <div className="col-md-4 mt-2">
                            <label>Inc Month </label>
                            <CustomMonthPicker
                              name="month"
                              value={month}
                              onChange={(date) => { setMonth(date); }}
                              onBlur={() => { console.log("Blurred! Value is:", month); }}
                              minDate={financialYearRange.start}
                              maxDate={financialYearRange.end}
                              disableFuture={true}
                              className="form-control form-control-sm"
                              classNamePrefix="react-select"
                            />
                          </div>
                          <div className="col-md-4 mt-2">
                            <label>Increment Type </label>
                            <CustomSelect
                              id="increment_types"
                              name="increment_types"
                              isMulti={false}
                              options={increment_type || []}
                              value={formik.values.increment_types || null}
                              onChange={(selectedOption) => {
                                formik.setFieldValue("increment_types", selectedOption);
                                ShowDetails(selectedOption);
                              }}
                              onBlur={() => formik.setFieldTouched("increment_types", true)}
                              className="react-select-container"
                              classNamePrefix="react-select"
                            />
                          </div>
                          {/* <div className="col-md-12 text-end mt-3">
                            <Button type="button" className="btn button-search" onClick={handleSearch}> <i className="fas fa-search me-1" /> Search</Button>
                          </div> */}
                        </Row>
                        <Row>
                          <TableContainer columns={columns} data={Array.isArray(filteredData) ? filteredData : []} isGlobalFilter={true} customPageSize={10} />
                        </Row>
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                </div>
              </CardBody>
            </Card>
          </Form>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default IncrementUpdate;
